import * as Scrivito from 'scrivito';
import { findHomepage } from './homepage';

// The 2-letter language code of the homepage the current page lives under
// (lowercased, 'en' when unknown). Every page sits under a language-specific
// Homepage obj, so this is the single source of truth for "which language is
// the visitor reading" — widgets must not re-derive it ad hoc (that is how
// the untranslated-English-in-German-view bugs happened in the first place).
export function pageLang() {
  const homepage = findHomepage(Scrivito.currentPage());
  const iso = homepage?.get('isoCodeLanguage') || 'en';
  return iso.slice(0, 2).toLowerCase();
}

// Pick the page-language entry from a { de: …, en: … } string map, falling
// back to English. For static UI strings (not CMS-bound fields).
export function pick(strMap, lang) {
  return strMap[lang] || strMap.en;
}

// Resolve a CMS string field that may still carry its untouched English
// scaffold default: if the saved value equals that default AND the visitor is
// reading the site in German AND a German replacement exists, return the
// replacement; otherwise return the value as-is (editors' explicit content
// always wins, whatever it is).
//
// Returns { text, localized } — `localized` is true when the German
// replacement was applied, which ContentTag-based callers need to decide
// whether to render a plain string instead of editable content.
export function resolveCmsField(rawValue, untouchedDefault, localized, lang) {
  const value = rawValue || untouchedDefault;
  if (lang === 'de' && value === untouchedDefault && localized) {
    return { text: localized, localized: true };
  }
  return { text: value, localized: false };
}
